export var getWtuAdditionalInfo = function (product) {
    if (!product) {
        return {};
    }
    var familyId = product.familyId, familyName = product.familyName, segmentType = product.segmentType;
    return { familyId: familyId, familyName: familyName, segmentType: segmentType };
};
